import React, {Component} from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

class CreatedDate extends Component {
    render() {
        const {created} = this.props
        const textTime = created ? moment(created).format('DD/MM/YYYY HH:mm') : '-'

        return (
            <td className='CreatedDate'>
                {textTime}
            </td>
        )
    }
}

CreatedDate.propTypes = {
    created: PropTypes.string,
}

export default CreatedDate
